import {ConjuntoCategoriaContabil} from '../../core/conjunto-categoria-contabil';
import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {Acesso} from 'src/app/core/acesso';
import {ConjuntoCategoriaContabilService} from 'src/app/services/conjunto-categoria-contabil/conjunto-categoria-contabil.service';
import {CategoriasContabeisService} from 'src/app/services/categorias-contabeis/categorias-contabeis.service';
import {ConfirmDialogComponent} from '../common/confirm-dialog/confirm-dialog.component';
import {CarregarPerfil} from 'src/app/core/carregar-perfil';
import {ConfiguracaoSeletor} from '../shared/interfaces/opcao-selecao.interface';
import {PlanosContas} from '../../core/planos-contas';
import * as _ from 'lodash';

@Component({
    selector: 'conjunto-categoria-contabil',
    templateUrl: './conjunto-categoria-contabil.component.html',
    styleUrls: ['./conjunto-categoria-contabil.component.css']
})
export class ConjuntoCategoriaContabilComponent implements OnInit, AfterViewInit {

    @ViewChild(MatPaginator) paginator: MatPaginator;

    mostrarTabela: boolean = false;
    msg: string;

    displayedColumns: string[] = ['categoriaOrigem', 'categoriaDestino', 'ativo', 'acoes'];
    dataSource: MatTableDataSource<ConjuntoCategoriaContabil> = new MatTableDataSource();

    perfilAcesso: Acesso = new Acesso();
    carregarPerfil: CarregarPerfil = new CarregarPerfil();

    idSelecionado: number = null;
    comboCategorias: any[] = [];

    // Filtros
    idCategoriaOrigem: number | null = null;
    idCategoriaDestino: number | null = null;
    ativo: string | null = 'todos';
    descricaoArgumentos: string = '';

    // Configuração para o seletor genérico
    configuracaoSeletorCategoria: ConfiguracaoSeletor = {
        campoExibicao: 'planoConta',
        habilitarPesquisa: true,
        camposPesquisa: ['planoConta'],
        tamanhoMinimoPesquisa: 1
    };

    constructor(
        private conjuntoCategoriaContabilService: ConjuntoCategoriaContabilService,
        private categoriasContabeisService: CategoriasContabeisService,
        private router: Router,
        private dialog: MatDialog,
        private activatedRoute: ActivatedRoute
    ) {
    }

    ngOnInit() {
        this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);

        this.getAll();
        this.carregarCategorias();
    }

    ngAfterViewInit() {
        this.dataSource.paginator = this.paginator;
    }

    carregarCategorias() {
        this.categoriasContabeisService.getAllView(false).subscribe((planosContas: PlanosContas[]) => {
            this.comboCategorias = planosContas;
        });
    }

    limpar() {
        this.mostrarTabela = false;
        this.dataSource.data = [];
        this.idSelecionado = null;
        this.idCategoriaOrigem = null;
        this.idCategoriaDestino = null;
        this.ativo = null;
        this.descricaoArgumentos = '';
    }

    consultar() {
        // Verificar se há algum filtro preenchido
        const temFiltros = this.idCategoriaOrigem != null ||
            this.idCategoriaDestino != null ||
            (this.ativo != null && this.ativo !== 'todos') ||
            (this.descricaoArgumentos != null && this.descricaoArgumentos.trim() !== '');

        if (temFiltros) {
            // Usar busca com filtros
            this.conjuntoCategoriaContabilService.getByFiltros(
                this.idCategoriaOrigem,
                this.idCategoriaDestino,
                this.ativo,
                this.descricaoArgumentos
            ).subscribe((conjuntos: ConjuntoCategoriaContabil[]) => {
                if (!conjuntos || conjuntos.length === 0) {
                    this.mostrarTabela = false;
                    this.msg = 'Nenhum conjunto encontrado com os filtros selecionados';
                } else {
                    this.dataSource.data = conjuntos;
                    this.mostrarTabela = true;
                }
            });
        } else {
            // Sem filtros, buscar todos
            this.getAll();
        }
    }

    atualizar(conjunto: ConjuntoCategoriaContabil) {
        this.router.navigate(['/conjuntos-categoria-contabil/cadastrar'], {queryParams: {id: conjunto.id}});
    }

    deletar(conjunto: ConjuntoCategoriaContabil) {
        this.chamaCaixaDialogo(conjunto);
    }

    chamaCaixaDialogo(conjunto: ConjuntoCategoriaContabil) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.data = {
            pergunta: `Tem certeza que deseja excluir a configuração do conjunto de contas contábeis?`,
            textoAuxiliar: `Conta Contábil Origem: "${this.resgatarDescricao(conjunto.idCategoriaOrigem) || 'Origem'}" - Conta Contábil Destino: "${this.resgatarDescricao(conjunto.idCategoriaDestino) || 'Destino'}"`,
            textoConfirma: 'SIM',
            textoCancela: 'NÃO'
        };

        const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(confirma => {
            if (confirma) {
                this.conjuntoCategoriaContabilService.excluir(conjunto.id).subscribe(() => {
                    this.limpar();
                    this.consultar();
                });
            } else {
                dialogRef.close();
            }
        });
    }

    getAll() {
        this.conjuntoCategoriaContabilService.getAll().subscribe((conjuntos: ConjuntoCategoriaContabil[]) => {
            this.dataSource.data = conjuntos ? conjuntos : [];
            this.verificaMostrarTabela(conjuntos);
        });
    }

    verificaMostrarTabela(conjuntos: ConjuntoCategoriaContabil[]) {
        if (!conjuntos || conjuntos.length === 0) {
            this.mostrarTabela = false;
            this.msg = 'Nenhum conjunto cadastrado.';
        } else {
            this.mostrarTabela = true;
        }
    }

    onCategoriaOrigemChange(event: any) {
        this.idCategoriaOrigem = event;
    }

    onCategoriaDestinoChange(event: any) {
        this.idCategoriaDestino = event;
    }

    onAtivoChange(event: any) {
        this.ativo = event.value;
    }

    resgatarDescricao(categoriaId: any) {
        const planoConta = _.cloneDeep(_.find(this.comboCategorias, {id: categoriaId}));

        if (planoConta)
            return planoConta.planoConta;
        else
            return '';
    }

}
